import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import SvgOrganization from '@material-ui/icons/SupervisorAccount';

const styles = (theme) => {
    return {
        section: {
            width: '95%',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: 24,
            overflow: 'hidden',
        },
        sectionTitleBlock: {
            display: 'inline-block',
            width: '100%',
            height: 64,
            textAlign: 'left',
            backgroundColor: 'rgba(206, 142, 64, 0.17)',
        },
        sectionTitleText: {
            display: 'inline-block',
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            fontSize: 26,
            fontVariant: 'small-caps',
        },
        sectionTitleIcon: {
            ...theme.iconStyle.size[36],
            ...theme.iconStyle.dark,
            display: 'inline-block',
            marginLeft: 12,
            marginRight: 16,
            marginTop: 14,
            marginBottom: 14,
            verticalAlign: 'middle',
        },
        sectionContentBlock: {
            height: 56,
            paddingLeft: 16,
            paddingRight: 16,
        },
        sectionContentLabel: {
            float: 'left',
            height: 24,
            marginTop: 16,
            marginBottom: 16,
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            fontVariant: 'small-caps',
            cursor: 'default',
        },
        sectionContentText: {
            float: 'right',
            marginTop: 16,
            marginBottom: 16,
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            '&$clickable': {
                color: theme.palette.secondary.main,
                cursor: 'pointer',
                textTransform: 'uppercase',
            },
        },
        sectionCenterText: {
            display: 'inline-block',
            marginTop: 16,
            marginBottom: 16,
            marginLeft: 'auto',
            marginRight: 'auto',
            color: theme.palette.text.secondary,
            verticalAlign: 'middle',
            '&$clickable': {
                color: theme.palette.secondary.main,
                cursor: 'pointer',
                textTransform: 'uppercase',
            },
            '&$disabled': {
                color: emphasize(theme.palette.primary.light, 0.87),
                cursor: 'auto',
                textTransform: 'uppercase',
            },
        },
        clickable: {},
        disabled: {},
        dialogControlGroup: {
            marginRight: 24,
            marginLeft: 24,
            marginBottom: 24,
        },
        dialogControl: {
            marginLeft: 16,
            marginRight: 0,
        }
    };
}

class OrganizationInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openLeaveDialog: false,
        };
    }

    render = () => {
        const { classes } = this.props;

        return (
            <Paper
                className={classes.section}
                elevation={1}
            >
                <div className={classes.sectionTitleBlock}>
                    <SvgOrganization className={classes.sectionTitleIcon} />
                    <Typography
                        className={classes.sectionTitleText}
                        align='left'
                        variant='h6'
                    >
                        Organization
                    </Typography>
                </div>
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Name
                    </Typography>
                    <Typography
                        className={classes.sectionContentText}
                        align='right'
                    >
                        {this.props.info.organization}
                    </Typography>
                </div>
                <Divider />
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Role
                    </Typography>
                    <Typography
                        className={classes.sectionContentText}
                        align='right'
                    >
                        {this.props.info.role === 'owner' ? 'Owner' : 'User'}
                    </Typography>
                </div>
                <Divider />
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Created
                    </Typography>
                    <Typography
                        className={classes.sectionContentText}
                        align='right'
                    >
                        {this._displayDate(this.props.info.organization_created)}
                    </Typography>
                </div>
                <Divider />
                {this._renderManageOrganization()}
                {/* {this._renderManageAPIToken()} */}
                {this._renderLeaveOrganization()}
                {this._renderLeaveDialog()}
            </Paper>
        );
    }

    _renderManageOrganization = () => {
        const { classes } = this.props;

        if (!this.props.info.member_count) {
            return null
        }

        return (
            <div>
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        Member
                    </Typography>
                    <Typography
                        className={classNames(classes.sectionContentText, classes.clickable)}
                        align='right'
                        onClick={this._handleManageOrganization}
                    >
                        Manage
                        </Typography>
                </div>
                <Divider />
            </div>
        );
    }


    _renderManageAPIToken = () => {
        const { classes } = this.props;

        if (!this.props.info.member_count) {
            return null
        }

        return (
            <div>
                <div className={classes.sectionContentBlock}>
                    <Typography
                        className={classes.sectionContentLabel}
                        align='left'
                        variant='subtitle1'
                    >
                        API Token Mangement
                    </Typography>
                    <Typography
                        className={classNames(classes.sectionContentText, classes.clickable)}
                        align='right'
                        onClick={this._handleManageAPIToken}
                    >
                        Manage
                        </Typography>
                </div>
                <Divider />
            </div>
        );
    }

    _renderLeaveOrganization = () => {
        const { classes } = this.props;

        const disableLeave = (!this.props.info.role || this.props.info.role === 'owner')

        const className = classNames(classes.sectionCenterText,
            (disableLeave) ? classes.disabled : classes.clickable);

        return (
            <div className={classes.sectionContentBlock}>
                <Typography
                    className={className}
                    align='center'
                    onClick={disableLeave ? null : this._handleLeaveOrganization}
                >
                    Leave Organization
                </Typography>
            </div>
        );
    }

    _renderLeaveDialog = () => {
        const { classes } = this.props;

        return (
            <div>
                <Dialog
                    fullWidth={true}
                    disableBackdropClick={false}
                    disableEscapeKeyDown={false}
                    open={this.state.openLeaveDialog}
                    onBackdropClick={this._handleLeaveDialogCancel}
                    onEscapeKeyDown={this._handleLeaveDialogCancel}
                >
                    <DialogTitle>
                        Are you sure?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you wish to leave the organization?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.dialogControlGroup}>
                        <Button
                            className={classes.dialogControl}
                            color='secondary'
                            autoFocus={true}
                            onClick={this._handleLeaveDialogCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            className={classes.dialogControl}
                            color='secondary'
                            autoFocus={true}
                            variant='contained'
                            onClick={this._handleLeaveDialogOk}
                        >
                            Leave
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

    _handleManageOrganization = (event) => {
        event.preventDefault();

        if (this.props.onManage) {
            this.props.onManage();
        }
    }

    _handleManageAPIToken = (event) => {
        event.preventDefault();

        if (this.props.onManageAPI) {
            this.props.onManageAPI();
        }
    }

    _handleLeaveOrganization = (event) => {
        event.preventDefault();

        this.setState({
            openLeaveDialog: true,
        });
    }

    _handleLeaveDialogOk = (event) => {
        event.preventDefault();

        this.setState({
            openLeaveDialog: false,
        });

        if (this.props.onLeave) {
            this.props.onLeave();
        }
    }

    _handleLeaveDialogCancel = (event) => {
        event.preventDefault();

        this.setState({
            openLeaveDialog: false,
        });
    }

    _displayDate = (timestamp) => {
        const d = new Date(timestamp * 1000);
        return d.toDateString();
    }
}

OrganizationInfo.propTypes = {
    info: PropTypes.object,
    onManage: PropTypes.func,
    // onManageAPI: PropTypes.func,
    onLeave: PropTypes.func,
}

export default withStyles(styles)(OrganizationInfo);
